import instance from "../api/instance";
import { logout } from "./sessionActions";

export const validateHardToken = (tokenData) => {
  return (dispatch) => {
    return instance.post(`/token`, tokenData).then((response) => {
      return response.data.data;
    })
    .catch((err) => {
      var statusCode = err.response.status;

      switch (statusCode) {
        case 401:
          dispatch(logout());
          break;
        default:
          return Promise.reject(err);
      }
    });
  }
}